import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { Deal } from '../models/shared/Deal'
import NotFoundPage from './NotFoundPage'
import { useFirebaseDoc } from '../hooks/firebaseHooks'
import { COLLECTIONS, MARKETING_WEBSITE } from '../utils/shared/constants'
import DealContent from '../components/DealContent'
import { UnAuthOrganizationContextProvider } from '../context/OrganizationContext'
import { useText } from '../context/TextContext'
import { useShareToken } from '../hooks/useShareToken'
import LoadingPage from './LoadingPage'


export default function SharedDealPage() {
    const text = useText();
    const { token, organization, loading } = useShareToken();
    const [deal] = useFirebaseDoc<Deal>(token
        ? `${COLLECTIONS.ORGANIZATIONS}/${token.orgId}/${COLLECTIONS.DEALS}/${token.dealId}`
        : '')


    if (!loading && !token) {
        return <NotFoundPage />
    }


    if (loading || !deal || !organization) {
        return <LoadingPage />
    }


    return (
        <UnAuthOrganizationContextProvider organization={organization} orgId={token?.orgId || ''}>

            <Container className='pt-2'>

                <DealContent
                    deal={deal}
                    readOnly={true}
                />

                <div className='center'>
                    <Link to={MARKETING_WEBSITE}>
                        <p className='text-muted'>{text.poweredByArbTask}</p>
                    </Link>
                </div>
            </Container>
        </UnAuthOrganizationContextProvider>
    )
}
